module.exports = __webpack_public_path__ + "media/country_flags/dz-c5fd57a3.png";